




































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import "@/plugins/googleMaps";
import { mapState } from "vuex";
import {
  ExperienceProductsRequests,
  ExperiencesRequests,
  NoProfileGiftsRequests,
  UtilitiesFunctions,
} from "@/helpers";
import SwiperCarousel from "@/components/SwiperCarousel.vue";
import Reservation from "../../models/reservation";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import RouteTranslations from "@/locales/routerTranslations";
import moment from "moment";

@Component({
  components: {
    SwiperCarousel,
    swiper,
    swiperSlide,
  },
  computed: {
    ...mapState("app", ["tagsList"]),
  },
})
export default class ExperienceDetail extends Vue {
  closeMenu: boolean = false;
  productsLoading: boolean = false;
  loading: boolean = true;
  centerMap?: any = null;
  redeemData?: any = null;
  isAlreadyRedeemed?: any = false;
  isRedeemCodeValid?: any = true;
  redeemCode?: any = null;
  experienceMarkers: Array<any> = [];
  experience?: any = null;
  productsList?: Array<any> = [];
  isOnline!: boolean;
  swiperOption: Object = {
    zoom: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };
  translations: any = RouteTranslations;
  testIcon: string =
    "https://res.cloudinary.com/divinea/image/upload/c_fill,h_15,w_15/v1/production/store/511e9c83103ef5641c50f6cafa255c17.png";

  created() {
    document.body.classList.add("experience-detail");
    this.$store.dispatch("booking/resetBookingDetails");
    this.getExperience().then(() => {
      console.log(this.experience);

      // change meta title & meta description

      var description = this.experience.description.replace(
        /(<([^>]+)>)/gi,
        ""
      );
      var url = "https://divinea/esperienza/" + this.experience.id;

      document.title = this.experience.metaTitle;
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", this.experience.metaDescription);

      // change Open Graph Meta

      document
        .querySelector(' meta[property="og:title"]')
        .setAttribute("content", this.experience.metaTitle);
      document
        .querySelector(' meta[property="og:description"]')
        .setAttribute("content", this.experience.metaDescription);
      document
        .querySelector(' meta[property="og:url"]')
        .setAttribute("content", url);
      document
        .querySelector(' meta[property="og:image"]')
        .setAttribute("content", this.experience.images[0]);

      const dataLayer: any = (window as any).dataLayer;

      dataLayer.push({
        event: "DetailView",
        ecommerce: {
          detail: {
            actionField: { list: this.experience.cellar.title },
            products: [
              {
                name: this.experience.title,
                id: this.experience.id,
                brand: this.experience.cellar.title,
              },
            ],
          },
        },
      });

      this.redeemCode = this.$route.query.redeem_code || null;
      if (this.redeemCode) {
        return NoProfileGiftsRequests.fetch(this.redeemCode)
          .then((response: any) => {
            this.loading = false;
            if (!response.redeemed) {
              this.redeemData = response;
            } else {
              this.isAlreadyRedeemed = true;
            }
          })
          .catch((error: Error) => {
            this.loading = false;
            this.isRedeemCodeValid = false;
          });
      } else {
        this.loading = false;
      }
    });
  }

  destroyed() {
    document.body.classList.remove("experience-detail");
  }

  openGiftDialog() {
    this.openReservationDialog({ isGift: true });
  }

  CheckOutReservationStep2() {
    const dataLayer: any = (window as any).dataLayer;

    //push add to cart GA product behavior for Reservation
    dataLayer.push({
      event: "addToCart",
      ecommerce: {
        add: {
          products: [
            {
              category: "Reservation",
              name: this.experience.title,
              id: this.experience.id,
              brand: this.experience.cellar.title,
            },
          ],
        },
      },
    });
  }

  CheckOutGiftStep2() {
    const dataLayer: any = (window as any).dataLayer;

    //push add to cart GA product behavior for Gift
    dataLayer.push({
      event: "addToCart",
      ecommerce: {
        add: {
          products: [
            {
              category: "Gift",
              name: this.experience.title,
              id: this.experience.id,
              brand: this.experience.cellar.title,
            },
          ],
        },
      },
    });
  }

  getReserveButtonLabel() {
    return this.redeemData
      ? this.$t("experienceView.detail.redeemButton")
      : this.$t("experienceView.detail.bookButton");
  }

  getExperience() {
    return new Promise((resolve, reject) => {
      return ExperiencesRequests.fetch(this.$route.params.id)
        .then((response: any) => {
          this.experience = response;
          const expType = this.experience.experienceTypeTags.find(
            (it: any) => it.categoryId === "exptype"
          );
          this.isOnline = expType && expType.code === "smart";
          this.getExperienceProducts();
          this.centerMap = {
            lat: parseFloat(
              this.experience.address ? this.experience.address.lat : 0
            ),
            lng: parseFloat(
              this.experience.address ? this.experience.address.lng : 0
            ),
          };
          this.experienceMarkers = [
            {
              title: this.experience.cellar.title,
              position: {
                lat: parseFloat(
                  this.experience.address ? this.experience.address.lat : 0
                ),
                lng: parseFloat(
                  this.experience.address ? this.experience.address.lng : 0
                ),
              },
              icon: {
                url: require("@/assets/icons/markerIcon.svg"),
                size: { width: 35, height: 35, f: "px", b: "px" },
                scaledSize: { width: 35, height: 35, f: "px", b: "px" },
              },
            },
          ];
          resolve();
        })
        .catch((error: Error) => {
          this.loading = false;
          this.$store.dispatch("app/setSnackbarMessage", {
            message: this.$t("experienceView.experienceNotValidErrorMessage"),
            color: "red",
          });
          reject();
        });
    });
  }

  getExpiredDate() {
    return moment(this.redeemData.expires_at).format("D MMMM YYYY");
  }

  getExperienceProducts() {
    this.productsLoading = true;
    ExperienceProductsRequests.with({
      ExperienceId: this.$route.params.id,
    })
      .fetchAll()
      .then((response: any) => {
        this.productsLoading = false;
        this.productsList = response;
      })
      .catch((error: Error) => {
        this.productsLoading = false;
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red",
        });
      });
  }

  askForInformation() {
    const data = {
      adults: 0,
      children: 0,
      startAt: null,
      duration: this.experience.duration,
      timetable: null,
      time: null,
      total: 0,
      giftId: null,
      priceCurrency: null,
      pricePerPerson: null,
      experienceId: this.experience.id,
      experience: this.experience,
      language:
        this.experience.experienceLanguagesTags.find(
          (e) => this.$i18n.locale == "it" && e.code == "lang_it"
        ) || {},
    };

    this.$store.dispatch("booking/resetBookingDetails");
    this.$store.dispatch(
      "booking/setBookingDetails",
      new Reservation().localDeserialization(data)
    );

    const toRoute: string = this.translations[this.$i18n.locale][
      "bookingSummary"
    ].link;
    this.$router.push({ path: toRoute });
  }

  get redeemLabelsText() {
    let s = "";
    const r = this.redeemData;
    if (r.adults) {
      s += `<strong>${r.adults}: ${this.experience.priceLabel}</strong>`;
    }
    if (r.children) {
      if (!!s) s += ", ";
      s += `<strong>${r.children}: ${this.experience.price2Label}</strong>`;
    }
    this.redeemData.priceLabels.forEach((pl) => {
      if (!!s) s += ", ";
      s += `<strong>${pl.quantity}: ${pl.title_translations["it"]}</strong>`;
    });
    return s;
  }

  openReservationDialog(customChildData: any = {}) {
    const data = {
      adults: 0,
      children: 0,
      startAt: null,
      duration: this.experience.duration,
      language: null,
      timetable: this.experience.timetable,
      time: null,
      total: 0,
      giftId: this.redeemCode,
      priceCurrency: this.experience.priceCurrency,
      pricePerPerson: this.experience.price,
      experienceId: this.experience.id,
      experience: this.experience,
      priceLabels: this.experience.experiencePriceLabels,
      priceExtras: this.experience.experiencePriceExtras,
    };
    this.$store.dispatch("booking/resetBookingDetails");
    this.$store.dispatch(
      "booking/setBookingDetails",
      new Reservation().localDeserialization(data)
    );

    this.$store
      .dispatch("app/setDialog", {
        type: "reservationDialog",
        state: true,
        childData: {
          ...customChildData,
          experience: this.experience,
          redeem: this.redeemData,
          giftId: this.redeemCode,
          isRedeemCodeValid: this.isRedeemCodeValid,
          isAlreadyRedeemed: this.isAlreadyRedeemed
        },
      })
      .then(() => {})
      .catch((error) => {
        console.error(error);
      });
  }

  goToLink(linkUrl: string, id: string) {
    const toRoute = UtilitiesFunctions.handleRoute(linkUrl);
    this.$router.push({ path: `${toRoute}/${id}` });
  }

  formatDuration(duration: string): string {
    console.log(duration);
    if (duration != null) {
      return duration
        .replace("0d", "")
        .replace(" 0h", "")
        .replace(" 0m", "");
    }
    return duration;
  }

  isGiftExpired() {
    return (
      this.redeemData &&
      this.redeemData.expires_at &&
      new Date(this.redeemData.expires_at) < new Date()
    );
  }
}
